import { Plugin } from '@ckeditor/ckeditor5-core';
import MediaEmbedEditing from '@ckeditor/ckeditor5-media-embed/src/mediaembedediting';

export default class MultiMediaEmbedEditing extends Plugin {
	static get pluginName() {
		return 'MultiMediaEmbedEditing';
	}

	init() {
		// No registrar nada nuevo: el schema de 'media' ya existe.
		// Solo accedemos al plugin original si queremos su registry o conversión.
		const base = this.editor.plugins.get(MediaEmbedEditing);
		this.registry = base.registry;
	}
}
